<!--<h1 mat-dialog-title>Résumé dossier</h1>-->
<div mat-dialog-content>

  <mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step [stepControl]="firstFormGroup"
      label="{{ 'modalAccepterRefuserExpertise.titreEtapeUne' | translate }} {{dossier.numeroDossier}} - {{formatCandidatName()}}">
      <form [formGroup]="firstFormGroup">
        <div class="row">
          <div class="col">
            <div id="content" class="content-frame">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br>
              <mat-checkbox formControlName="readAndValidateSummary">
                {{ 'modalAccepterRefuserExpertise.validationEtapeUne' | translate }}
              </mat-checkbox>

              <button style="margin-left: 30px" mat-raised-button color="accent"
              matStepperNext>{{ 'general.suivant' | translate }}</button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step label="{{ 'modalAccepterRefuserExpertise.titreEtapeDeux' | translate }}">
        <mat-radio-group [(ngModel)]="etatAcceptation" (ngModelChange)="etatcommentaire = ''  ">
          <!--Refus-->
          <br>
            <mat-radio-button [value]="false">
              <span
              class="font-weight-bold">{{ 'modalAccepterRefuserExpertise.etapeDeux.jeRefuse' | translate }}</span>
            </mat-radio-button>
            @if (etatAcceptation === false) {
              <div>
                <p class="mt-0 mb-1 " class="description">
                  {{ 'modalAccepterRefuserExpertise.etapeDeux.jeRefuseJustification' | translate }}
                </p>
                <textarea maxlength="500" [(ngModel)]="etatcommentaire" name="commmentaireRefus"
                class="form-control mb-1" cols="30" rows="5"></textarea>
                {{etatcommentaire.length + '/500'}}
              </div>
            }

            <br>
              <div class="clearfix"></div>

              <!--Acceptation-->
              <mat-radio-button class="align-bottom" [value]="true" style="width: 100%; display: block">
                <span class="font-weight-bold">
                  {{ 'modalAccepterRefuserExpertise.etapeDeux.jAccepte' | translate }}
                </span>
              </mat-radio-button>
              <p class="mt-0  mb-1" class="description">
                {{ 'modalAccepterRefuserExpertise.etapeDeux.jAccepteDescription' | translate }}
              </p>
              @if (etatAcceptation === true) {
                <div>
                  <p class="mt-0  mb-1 font-weight-bold font-italic" style="margin-left: 27px;">
                    {{ 'modalAccepterRefuserExpertise.etapeDeux.jAcceptePrecision' | translate }}
                  </p>
                  <textarea maxlength="500" [(ngModel)]="etatcommentaire"
                  name="commmentaireAcceptation" class="form-control mb-1" cols="30" rows="5"></textarea>
                  {{etatcommentaire.length + '/500'}}
                </div>
              }


              <button [disabled]="isBusy || etatAcceptation === undefined || (!etatAcceptation && etatcommentaire.length === 0)" (click)="save()" mat-raised-button color="primary"
              class="pull-right">{{ 'general.save' | translate }}</button>
              <div class="clearfix"></div>
            </mat-radio-group>


          </mat-step>

        </mat-horizontal-stepper>

      </div>


      <div mat-dialog-actions class="row">
        <button mat-stroked-button color="primary"
        (click)="charteDeon()">{{ 'front.modaleCharteDeontologique.titre' | translate }}</button>

        <button mat-button [mat-dialog-close]="false">{{'general.close' | translate}}</button>
      </div>
